import "./Navbar.css";
import Logo from "../../images/logo.png";
import {Link} from 'react-router-dom';

export default function Navbar() {

    return (
        <div id="navbar">
            <Link to="/">
                <img id="logo" src={Logo} className="logo" alt="logo" />
            </Link>
            <div id="navbarButtonContainer">
                <Link id="navbarButton" to="/home">HOME</Link>
                <Link id="navbarButton" to="/">CHI SIAMO</Link>
                <Link id="navbarButton" to="/ourmission">LA NOSTRA MISSION</Link>
                <Link id="navbarButton" to="/contactus">CONTATTACI</Link>
                <Link id="navbarButton" to="/workwithus">LAVORA CON NOI</Link>
            </div>
        </div>
    )
}